import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { ExpansionPanel, ExpansionPanelDetails } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  details: {
    flexDirection: 'column',
    marginLeft: theme.spacing(2)
  }
}));

export default function DetalhesFiliado(props) {
  const classes = useStyles();
  const { visitaFiliado, pedido } = props;

  return (
    <ExpansionPanel>
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1}>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Nome:</Typography>
              </Grid>
              <Grid item md={9} xs={9}>
                <Typography>
                  <b>{visitaFiliado.filiado.nome}</b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>RG:</Typography>
              </Grid>
              <Grid item md={9} xs={9}>
                <Typography>
                  <b>{visitaFiliado.filiado.rg}</b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>CPF:</Typography>
              </Grid>
              <Grid item md={9} xs={9}>
                <Typography>
                  <b>{visitaFiliado.filiado.cpf}</b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Email:</Typography>
              </Grid>
              <Grid item md={9} sm={9} xs={12}>
                <Typography>
                  <b>{visitaFiliado.filiado.email}</b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Código:</Typography>
              </Grid>
              <Grid item md={9} sm={9} xs={12}>
                <Typography>
                  <b>
                    {visitaFiliado.filiado.codigo
                      ? visitaFiliado.filiado.codigo
                      : 'Não informado'}
                  </b>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1}>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Anuidade:</Typography>
              </Grid>
              <Grid item md={9} sm={9} xs={12}>
                <Typography>
                  <b>
                    {visitaFiliado.filiado.validadeAnuidade
                      ? moment(visitaFiliado.filiado.validadeAnuidade).format(
                          'DD/MM/YYYY'
                        )
                      : 'Não informado'}
                  </b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Entrada:</Typography>
              </Grid>
              <Grid item md={9} sm={9} xs={12}>
                <Typography>
                  <b>
                    {moment(visitaFiliado.dataEntrada).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                  </b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Saída:</Typography>
              </Grid>
              <Grid item md={9} sm={9} xs={12}>
                <Typography>
                  <b>
                    {moment(visitaFiliado.dataSaida).format('DD/MM/YYYY HH:mm')}
                  </b>
                </Typography>
              </Grid>
              <Grid item md={3} sm={3} xs={12}>
                <Typography>Valor hora de clube:</Typography>
              </Grid>
              <Grid item md={9} sm={9} xs={12}>
                <Typography>
                  <b>
                    {(visitaFiliado.valorHoraClube
                      ? visitaFiliado.valorHoraClube
                      : 0
                    ).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </b>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}
